// src/hooks/useBillingShortcuts.ts

import { useEffect } from 'react';

const useBillingShortcuts = () => {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      switch (e.code) {
        case 'F1':
          e.preventDefault();
          document.dispatchEvent(new CustomEvent('shortcut-open-product'));
          break;
        case 'F2':
          e.preventDefault();
          document.dispatchEvent(new CustomEvent('shortcut-add-customer'));
          break;
        case 'F3':
          e.preventDefault();
          document.dispatchEvent(new CustomEvent('shortcut-apply-discount'));
          break;
        case 'F12':
          e.preventDefault();
          document.dispatchEvent(new CustomEvent('shortcut-complete-sale'));
          break;
        case 'Escape':
          document.dispatchEvent(new CustomEvent('shortcut-cancel-bill'));
          break;
        default:
          break;
      }
    };

    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, []);
};

export default useBillingShortcuts;